import React from 'react'
import { ChevronDown, Circle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import store from '../../../state/store'

class DisablePriorityButton extends React.Component {

  onClick = () => {
    store.emit('enquiry:priority:disable', this.props.enquiry_id)
  }

  render() {
    const title = 'Click to remove enquiry from your priority list'

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm">
            <Circle className="size-3.5"/> Priority <ChevronDown className="size-3.5"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={this.onClick} title={title}>Remove from Priority</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default DisablePriorityButton
